import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from 'src/services/auth.service';

import { ToastrService } from 'ngx-toastr';
import {Message} from "@model/Message";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthService, private toastr: ToastrService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError(err => {

      if ((err.status === 401 && (err.error.msg !== 'TOKEN_EXPIRED' ||
          err.error.msg === 'Token not provided' || err.error.msg === 'TOKEN_INVALID')) || err.status === 403) {
        this.toastr.error(Message.AUTHORIZATION);
        this.authenticationService.disconnect().subscribe(() => {
          this.authenticationService.logout();
          location.reload();
        });
      }

      return throwError(err);
    }))
  }
}
